export default __webpack_public_path__ + "static/media/LeanTaiichiOhono.eddb2060.jpg";